<template>
  <MainContent
    class="mt-[1.8rem] px-[4.8rem] py-[2.4rem] sm:mt-0 sm:px-[1.6rem] sm:py-[3.2rem]"
    :fullHeight="true"
  >
    <h3 class="text-black md:text-[2.4rem] capitalize sm:text-[2.5rem] sm:font-normal sm:pb-[1.6rem]">{{ title }}</h3>
    <div class="flex flex-col items-center justify-center gap-[1.6rem] rounded-[2.4rem] bg-white px-[3.2rem] py-[6.4rem] text-center sm:px-[2.4rem] sm:py-[4.8rem]">
      <div v-if="showIcon" class="flex h-[5.6rem] w-[5.6rem] items-center justify-center rounded-full bg-blue-50 text-blue-600">
        <slot name="icon">
          <IconCalendar :size="32" />
        </slot>
      </div>
      <p class="text-[1.8rem] font-semibold text-gray-700">
        {{ message }}
      </p>
      <p v-if="description" class="max-w-[42rem] text-[1.4rem] text-gray-500">
        {{ description }}
      </p>
      <AppButton
        v-if="buttonLabel"
        :label="buttonLabel"
        :to="buttonTo"
        :variant="buttonVariant"
        class="mt-[0.8rem]"
      />
    </div>
  </MainContent>
</template>

<script>
import { defineComponent } from 'vue';
import MainContent from '@/components/design/mainContent.vue';
import AppButton from '@/components/buttons/AppButton.vue';
import IconCalendar from '@/components/icons/IconCalendar.vue';

export default defineComponent({
  name: 'AccountEmptyState',
  components: {
    MainContent,
    AppButton,
    IconCalendar,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    message: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      default: '',
    },
    buttonLabel: {
      type: String,
      default: '',
    },
    buttonTo: {
      type: [String, Object],
      default: null,
    },
    buttonVariant: {
      type: String,
      default: 'primary',
    },
    showIcon: {
      type: Boolean,
      default: true,
    },
  },
});
</script>

<style scoped>
</style>
